module.exports = __webpack_public_path__ + "5c6f59d076d4db10a8193fab7aaae095.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/empty.png
// module id = 1106
// module chunks = 0